var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "check"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6348_6084",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6348_6084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check_2",
    d: "M15.6787 31.0135C15.2929 31.3796 14.688 31.3796 14.3021 31.0135L4.0985 21.3317C3.68292 20.9374 3.68292 20.2752 4.0985 19.8809L5.55978 18.4943C5.94563 18.1282 6.55056 18.1282 6.93641 18.4943L14.3021 25.4833C14.688 25.8494 15.2929 25.8494 15.6787 25.4833L33.0649 8.98636C33.4507 8.62025 34.0557 8.62025 34.4415 8.98636L35.9028 10.3729C36.3184 10.7672 36.3184 11.4294 35.9028 11.8237L15.6787 31.0135Z",
    fill: "#108A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f4ba82ac0a5bbeffea3f9a8f89c1118a.svg";
export { ForwardRef as ReactComponent };